import type { StorageKeys } from "./StorageKeys.type";

// STORAGE_KEYS VALUES MUST BE UNIQUE!
// TODO convert `STORAGE_KEYS` constant into enum at the end of all list
// tables migrations and replace `TableViewKey` type by the new enum
export const STORAGE_KEYS = {
  ACTIVITIES: "acts",
  ACTIVITIES_BATCH: "acts-batc",
  ASSETS: "asts",
  ASSET_TYPE_TEMPLATES: "temps-asts",
  ASSETS_COMPONENTS: "asts-asts",
  ASSETS_INTERVENTIONS: "asts-ints",
  ASSETS_OBSERVATIONS: "asts-obss",
  ENTITY_TEMPLATES: "entity-templates",
  INTERVENTIONS: "ints",
  INTERVENTION_TEMPLATES: "temps-ints",
  INTERVENTIONS_OBSERVATIONS: "ints-obss",
  INTERVENTIONS_RECOMMENDATIONS: "ints-recs",
  JOB_MODULES: "jobm",
  LOCATIONS: "locs",
  LOCATIONS_SECTORS: "locs-secs",
  LOCATIONS_ASSETS: "locs-asts",
  LOCATIONS_INTERVENTIONS: "locs-ints",
  LOCATIONS_PROJECTS: "locs-pros",
  MY_SPACE_FAVORITES: "mysp-favs",
  MY_SPACE_INTERVENTIONS: "mysp-ints",
  MY_SPACE_PROJECTS: "mysp-pros",
  MY_SPACE_RECENTS: "mysp-recs",
  OBSERVATIONS: "obss",
  OBSERVATIONS_RECOMMENDATIONS: "obss-recs",
  ORGANIZATIONS: "orgs",
  ORGANIZATIONS_LOCATIONS: "orgs-locs",
  ORGANIZATIONS_PROJECTS: "orgs-pros",
  PROJECTS: "pros",
  PROJECTS_ASSOCIATE: "pros-asso",
  PROJECTS_INTERVENTIONS: "pros-ints",
  SEVERITY_GRID: "sevd",
  USERS: "uses",
  USERS_INTERVENTIONS: "uses-ints",
} as const;
export const STORAGE_KEYS_VALUES = Object.values(STORAGE_KEYS) as StorageKeys[];
